import React from 'react';
import styled from 'styled-components';

import Navigation from './navigation';
import Introduction from './introduction';
import Information from './information';
import Considerations from './considerations';

const AdvancedInfoWrapper = styled.div`
	box-shadow: 0px 0px 12px rgb(0 0 0 / 12%);

	@media
		${props => props.theme.device.lgDesktop},
		${props => props.theme.device.desktop} {
		margin-top: 16px;
	}
`;

const AdvancedInfo = (): JSX.Element => (
	<AdvancedInfoWrapper>
		<Navigation />
		<Introduction />
		<Information />
		<Considerations />
	</AdvancedInfoWrapper>
);

export default AdvancedInfo;
